import {NUMBER} from '@drivesally/sally-fw/lib/inputTypes';

// attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// types
import formattedInteger from '@drivesally/sally-fw/lib/type/types/formattedInteger.type';
import number from '@drivesally/sally-fw/lib/type/types/number.type';

export default attribute({
  type: NUMBER,
  attribute: 'same_day_reservation_time_buffer',
  display: formattedInteger,
  input: formattedInteger,
  api: number,
  label: {
    default: 'Same Day Reservation Time Buffer (hours)',
    short: 'Same Day Reservation Time Buffer (hours)',
  },
});
